import { getCurrentUserApi } from '@apis/seller-center/profile-settings.js';
import { setAuthorized, setUserInfo } from '@reducers/seller-center/userinfo-slice/index.js';
import { isCP } from '@utils/app-utils.js';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useSellerCenterAuth = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.userData);
  const [loading, setLoading] = useState(!isCP());

  useEffect(() => {
    const initAuth = async () => {
      try {
        setLoading(true);
        const res = await getCurrentUserApi();
        const currentUser = res?.current_user;
        dispatch(
          setUserInfo({
            authenticated: true,
            initialized: true,
            userProfile: { ...currentUser, image: currentUser?.store?.logo?.sizes?.thumbnail },
            storeId: currentUser?.store?.id,
            admin: res?.admin,
          })
        );
      } catch {
        dispatch(setAuthorized(false));
      } finally {
        setLoading(false);
      }
    };

    if (!isCP()) {
      initAuth();
    }
  }, [dispatch]);

  return { userInfo, authLoading: loading };
};

export default useSellerCenterAuth;
